import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col } from 'reactstrap'
import moment from 'moment'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import ExpedientWidget from './ExpedientWidget'
import HoursBank from './HoursBank'
import Workload from './Workload'
import WorkloadGraph from './WorkloadGraph'
import ActivitiesGraph from './ActivitiesGraph'
import Updates from './Updates'
import News from './News'
import Agenda from './Agenda'
import ProjectLinks from './ProjectsLinks'
import Tasks from './Tasks'
import Todo from './Todo'
import { getMonthBalance, getHoursBank } from '../../store/ducks/humanResources'
import { getOikosId, getPfById, getPfProjectsByPfId } from '../../utils/fc'
import ProductsApprovement from './ProductsApprovement'
import EPApprovement from './EPApprovement'
import FaturamentoProximosCards from './FaturamentoProximosCards'
import MaterialTable from '../../components/MaterialTable/MaterialTable'
import BlurOverlay from '../../components/TestPhaseComponent/BlurOverlay'
import ModalErro from '../../components/Modals/ModalError/ModalError'

class Dashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      time: moment(),
      projects: null,
    }
  }

  componentDidMount() {
    const { getMonthBalance, getHoursBank } = this.props
    const { user } = this.props.auth;

    this.interval = setInterval(() => this.setState({ time: moment() }), 1000)

    getMonthBalance();
    getHoursBank();
    this.loadProjects(user.pf_id);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  loadProjects = async (id) => {
    const res = await getPfProjectsByPfId(id)
    this.setState({projects: res})
  }

  render() {
    const { monthBalance, hoursBank } = this.props.humanResources
    const { time } = this.state
    const { user } = this.props.auth;

    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Dashboard"
            breadcrumbItems={[{
              title: (moment(time).format('dddd, DD [de] MMMM [de] YYYY, HH:mm')).toLowerCase(),
            }]}
          />
          <Row>
              <Col xl={8}>
                {/*<BlurOverlay text='Em manutenção' blurAmount='2px'></BlurOverlay>*/}
                <FaturamentoProximosCards />
                <Row>
                  <ExpedientWidget />
                  <Workload
                    value={monthBalance && monthBalance.t_timestamp ? monthBalance.t_timestamp : 'Carregando...'}
                    percentage={monthBalance && monthBalance.percentual ? monthBalance.percentual : 0}
                  />
                  <HoursBank
                    value={
                      hoursBank && hoursBank.banco_acumulado_timestamp ? hoursBank.banco_acumulado_timestamp : 'Carregando...'
                    }
                    percentage={
                      hoursBank && hoursBank.banco_acumulado_var ? hoursBank.banco_acumulado_var : 0
                    }
                    variation={
                      hoursBank && hoursBank.banco_acumulado_var_abs ? hoursBank.banco_acumulado_var_abs : 0
                    }
                  />
                </Row>
                <WorkloadGraph />
                <ActivitiesGraph />

                {
                  user &&
                  <MaterialTable pf_id={user.pf_id}/>
                }
              </Col>
            <Col xl={4}>
              {
                user && this.state.projects &&
                <ProjectLinks userOikosId={user.pf_id} projects={this.state.projects}/>
              }
              {user && user.dpto_id === 4 &&
                <ProductsApprovement userOikosId={user.pf_id}/>
              }
              {user && (user.pf_cargo) && ((user.pf_cargo).includes("Diretor") ||
              (user.pf_cargo).includes("Gerente") ||
              (user.pf_cargo).includes("Desenvolvedor")) &&
                <EPApprovement userOikosId={user.pf_id} />
              }
              <Agenda />
              {/*<News />*/}
              {/*<Updates />*/}
            </Col>
          </Row>
        </Container>
        {/*
        <ModalErro openModalErro={this.props.firstTime} onClosed={this.props.handleFirstTime}
        title='Atenção!'
        text={
          <>
            <span>O sistema de ponto está apresentando instabilidades na exibição dos dados. <strong>Todas as marcações continuam sendo registradas corretamente.
            Por favor, continue batendo o ponto normalmente.</strong> Assim que o sistema for normalizado, os dados estarão disponíveis para consulta.</span><br/>
            <span>Agradecemos sua compreensão.</span>
          </>
        }/>
        */}
      </div>
    )
  }
}

const mapStateToProps = state => ({ humanResources: state.humanResources, auth: state.auth })
const mapDispatchToProps = dispatch => bindActionCreators({
  getMonthBalance,
  getHoursBank,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
